export type AbcClass = "A" | "B" | "C";

/**
 * Classe ABC pela fatia acumulada ANTES do item (lista em ordem decrescente de receita).
 * Quem leva o acumulado a passar de 80% ainda é A: o maior cliente é sempre A, mesmo que sozinho
 * seja 100% da receita. Pela fatia depois do item, um cliente único caía em C.
 */
export function abcClass(shareBefore: number): AbcClass {
  if (shareBefore < 0.8) return "A";
  if (shareBefore < 0.95) return "B";
  return "C";
}

/** Classes e fatia acumulada (depois do item) de uma lista já ordenada por valor decrescente. */
export function abcCurve(values: number[]): Array<{ abc: AbcClass; cumulativeShare: number }> {
  const total = values.reduce((s, v) => s + v, 0);
  let cumulative = 0;
  return values.map((v) => {
    const before = total > 0 ? cumulative / total : 0;
    cumulative += v;
    return { abc: abcClass(before), cumulativeShare: total > 0 ? cumulative / total : 0 };
  });
}
